import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-custom-table-zoom',
  templateUrl: './custom-table-zoom.component.html',
  styleUrls: ['./custom-table-zoom.component.css']
})
export class CustomTableZoomComponent implements OnInit {
  @Input() zoomedIn: boolean
  @Input() zoomedOut: boolean
  @Output() ZoomIn: EventEmitter<boolean> = new EventEmitter<boolean>();


  //////useing viewChield in Parent 
  constructor() { }

  addZoom(id: boolean) {
    this.ZoomIn.emit(id);
}


  zoomIn() {
    if (!this.zoomedIn) {
      this.zoomedIn = true;
    } else if (!this.zoomedOut) {
      this.zoomedOut = true;
    }
  }

  zoomOut() {
    if (this.zoomedOut) {
      this.zoomedOut = false;
    } else if (this.zoomedIn) {
      this.zoomedIn = false;
    }
  }

  resetZoom() {
    this.zoomedIn = false;
    this.zoomedOut = false;
  }

  ngOnInit() {



  }

}
